(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ZugLabelFamilyAdjustmentCarriers = api;
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function positiveInteger(value) {
    var parsed = Number(value);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
  }

  function readContract(container) {
    var eligible = !!container &&
      container.getAttribute('data-zug-label-adjustment-contract') === 'true';
    if (!eligible) return { eligible: false, valid: false };

    var contract = {
      eligible: true,
      family: container.getAttribute('data-zug-label-adjustment-family') || '',
      productId: positiveInteger(
        container.getAttribute('data-zug-label-adjustment-product-id')
      ),
      dollarVariantId: positiveInteger(
        container.getAttribute('data-zug-label-dollar-variant-id')
      ),
      centVariantId: positiveInteger(
        container.getAttribute('data-zug-label-cent-variant-id')
      )
    };
    contract.valid = (
      (contract.family === 'roll_labels' ||
        contract.family === 'label_sheets') &&
      !!contract.productId &&
      !!contract.dollarVariantId &&
      !!contract.centVariantId &&
      contract.dollarVariantId !== contract.centVariantId
    );
    return contract;
  }

  return {
    readContract: readContract
  };
});
